import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { PropertySearchOption } from "../models/property-heading.model";
import { PropertiesSearchZoningComponent } from "../../properties-search/properties-search-zoning/properties-search-zoning.component";
import { PropertiesSearchSectionalTitleComponent } from "../../properties-search/properties-search-sectional-title/properties-search-sectional-title.component";
let PropertyService = class PropertyService {
    advancedSearchComponentLookup;
    constructor() { }
    initializeAdvancedPropertySearchComponents() {
        // @ts-ignore
        this.advancedSearchComponentLookup = new Map([
            [
                PropertySearchOption.PropertyZoning,
                PropertiesSearchZoningComponent,
            ],
            [
                PropertySearchOption.SectionalTitle,
                PropertiesSearchSectionalTitleComponent
            ]
        ]);
    }
    static ctorParameters = () => [];
};
PropertyService = __decorate([
    Injectable({
        providedIn: "root"
    })
], PropertyService);
export { PropertyService };
